
import {observer} from "mobx-react";
import React from "react";
import {FormProps, lovValue} from "../../core/form/formUtils";
import ProjectVersionLopFilling from "../domain/project/projectVersionLopFillingDomain";
import {DefinitionType} from "../../core/form/form";
import {MdCheckbox, MdTextField} from "../../core/components/fields/fields";
import {Validate} from "../../core/form/validate";
import {createForm} from "../../core/form/createForm";
import StyledSelect from "../../core/components/fields/styledSelect";
import {optionsSearch} from "../../core/common/service/commonDataService";
import {PROJECT_MATERIAL_ENTITY} from "../entityConstants";

@observer
class ProjectVersionLopFillingsForm extends React.Component<FormProps<ProjectVersionLopFilling, ProjectVersionLopFilling>, any> {

  render(): JSX.Element | false | null {
    let {dataObject} = this.props;
    let fields = dataObject.getFormFields(ProjectVersionLopFillingsFormDefinition.formName);
    let {
      name, width, height, glazingArea, glazingMaterial, glazingMass, floorLevel, reachableByLadder, enduranceClass, acousticIsolation, partiesOrientation,
      angleAlpha, angleBeta, angleGama, angleDelta, angleEpsilon, angleZeta, angleEta, angleShieldingZ
    } = fields;
    return (
      <div>
        <div className='row'>
          <div className='fx col-xs-4 col-sm-4'>
            <MdTextField {...name.props}/>
            <Validate field={name} value={name.props.value} />
          </div>
          <div className='fx col-xs-2 col-sm-2'>
            <MdTextField {...width.props}/>
            <Validate field={width} value={width.props.value} />
          </div>
          <div className='fx col-xs-2 col-sm-2'>
            <MdTextField {...height.props}/>
            <Validate field={height} value={height.props.value} />
          </div>
          <div className='fx col-xs-2 col-sm-2'>
            <MdTextField {...glazingArea.props}/>
            <Validate field={glazingArea} value={glazingArea.props.value} />
          </div>
          <div className='fx col-xs-2 col-sm-2'>
            <MdTextField {...glazingMass.props}/>
            <Validate field={glazingMass} value={glazingMass.props.value} />
          </div>
        </div>
        <div className='row'>
          <div className='fx col-xs-2 col-sm-2'>
            <MdTextField {...floorLevel.props}/>
            <Validate field={floorLevel} value={floorLevel.props.value} />
          </div>
          <div className='fx col-xs-2 col-sm-2'>
            <StyledSelect {...enduranceClass.props}/>
            <Validate field={enduranceClass} value={enduranceClass.props.value} />
          </div>
          <div className='fx col-xs-4 col-sm-4'>
            <MdTextField {...acousticIsolation.props}/>
            <Validate field={acousticIsolation} value={acousticIsolation.props.value} />
          </div>
          <div className='fx col-xs-4 col-sm-4'>
            <StyledSelect {...glazingMaterial.props} async asterixForAll clearable loadOptions={optionsSearch.bind(this, PROJECT_MATERIAL_ENTITY, {projectVersionId : lovValue(dataObject.projectVersion)})} />
            <Validate field={glazingMaterial} value={glazingMaterial.props.value}/>
          </div>
        </div>
        <div className='row'>
          <div className='fx col-xs-4 col-sm-4'>
            <MdCheckbox {...partiesOrientation.props} />
            <Validate field={partiesOrientation} value={partiesOrientation.props.value} />
          </div>
          <div className='fx col-xs-4 col-sm-4'>
            <MdCheckbox {...reachableByLadder.props} />
            <Validate field={reachableByLadder} value={reachableByLadder.props.value} />
          </div>
        </div>
        <div className='row'>
          <div className='fx col-xs-3 col-sm-3'>
            <MdTextField {...angleAlpha.props}/>
            <Validate field={angleAlpha} value={angleAlpha.props.value} />
          </div>
          <div className='fx col-xs-3 col-sm-3'>
            <MdTextField {...angleBeta.props}/>
            <Validate field={angleBeta} value={angleBeta.props.value} />
          </div>
          <div className='fx col-xs-3 col-sm-3'>
            <MdTextField {...angleGama.props}/>
            <Validate field={angleGama} value={angleGama.props.value} />
          </div>
          <div className='fx col-xs-3 col-sm-3'>
            <MdTextField {...angleDelta.props}/>
            <Validate field={angleDelta} value={angleDelta.props.value} />
          </div>
          <div className='fx col-xs-3 col-sm-3'>
            <MdTextField {...angleEpsilon.props}/>
            <Validate field={angleEpsilon} value={angleEpsilon.props.value} />
          </div>
          <div className='fx col-xs-3 col-sm-3'>
            <MdTextField {...angleZeta.props}/>
            <Validate field={angleZeta} value={angleZeta.props.value} />
          </div>
          <div className='fx col-xs-3 col-sm-3'>
            <MdTextField {...angleEta.props}/>
            <Validate field={angleEta} value={angleEta.props.value} />
          </div>
          <div className='fx col-xs-3 col-sm-3'>
            <MdTextField {...angleShieldingZ.props}/>
            <Validate field={angleShieldingZ} value={angleShieldingZ.props.value} />
          </div>
        </div>
      </div>
    );
  }
}


export const ProjectVersionLopFillingsFormDefinition: DefinitionType = {
  formName: 'ProjectVersionLopFillingsForm',
  fields: [
    {name : 'name', validators : ['IsRequired']},
    {name : 'width',  validators: ['IsRequired', 'IsNumber']},
    {name : 'height', validators: ['IsRequired', 'IsNumber']},
    {name : 'glazingArea', validators: ['IsRequired', 'IsNumber']},
    {name : 'glazingMaterial',validators: ['IsRequired']},
    {name : 'glazingMass', validators: ['IsRequired', 'IsNumber']},
    {name : 'floorLevel', validators: ['IsRequired']},
    {name : 'reachableByLadder'},
    {name : 'enduranceClass', validators: ['IsRequired']},
    {name : 'acousticIsolation', validators: ['IsRequired', 'IsNumber']},
    {name : 'partiesOrientation'},
    {name : 'angleAlpha', validators: ['IsRequired', 'IsNumber']},
    {name : 'angleBeta', validators: ['IsRequired', 'IsNumber']},
    {name : 'angleGama', validators: ['IsRequired', 'IsNumber']},
    {name : 'angleDelta', validators: ['IsRequired', 'IsNumber']},
    {name : 'angleEpsilon', validators: ['IsRequired', 'IsNumber']},
    {name : 'angleZeta', validators: ['IsRequired', 'IsNumber']},
    {name : 'angleEta', validators: ['IsRequired', 'IsNumber']},
    {name : 'angleShieldingZ', validators: ['IsRequired', 'IsNumber']},
  ]
};

export default createForm(ProjectVersionLopFillingsFormDefinition, null)(ProjectVersionLopFillingsForm);



// WEBPACK FOOTER //
// ./src/sbtool/component/projectVersionLopFillingsForm.tsx